import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserResolved } from '../models/User';
import { AccountService } from './account.service';
import { OAuthServiceService } from './o-auth-service.service';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root'})
export class UserResolverService implements Resolve<UserResolved>{

  

  constructor(private accountService: AccountService,
    private tenantService:TenantService,
    private oauthService: OAuthServiceService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UserResolved | Observable<UserResolved> | Promise<UserResolved> {
    
    const id = route.paramMap.get('id') as string;    
    const tenantdb :string = this.tenantService.currentTenantName;

    console.log("============> user-resolver: userid = ", id);

    if (id === '') {
      const message = `No User id was provided: ${id}`;
      console.log(message);
      //return of({ userDto: null, error: message });
      return of(new UserResolved)
    }

    if (tenantdb === this.tenantService.SystemManagerAbbreviation ||  tenantdb === String(null) || tenantdb === '') {
      return this.accountService.getUser(id)
        .pipe(map(userDto => ({userDto: userDto})),
          catchError(error => {
            var ur = new UserResolved;
            ur.error = "Retrieval error: ";
            console.log("user-resolver: UserResolved = ", ur);
            const message = `Retrieval error: ${error}`;
            console.log(message);
            //return of({ projectDto: null, error: message });
            return of(ur);
          }));
    }
    else {
      return this.tenantService.getUser(tenantdb, id)
      .pipe(map(userDto => ({userDto: userDto})),
      catchError(error => {
            var ur = new UserResolved;
            ur.error = "Retrieval error: ";
            console.log("user-resolver: UserResolved = ", ur);
            const message = `Retrieval error: ${error}`;
            console.log(message);
            //return of({ projectDto: null, error: message });
            return of(ur);
        // const message = `Retrieval error: ${error}`;
        // console.error(message);
        // //return of({ projectDto: null, error: message });
        // return of(new UserResolved)
      }));
    }
  }
}
